import { HariseninFooter } from "@components/harisenin"
import { Header } from "@components/header"
import { BasicLink } from "@components/typography"
import { Helmet } from "@helpers/Helmet"
import { Job } from "@interfaces/career"
import JobsServices from "@services/jobs.services"
import { DetailBanner, DetailBody, OtherVacancies } from "@modules/career-detail/components"
import clsx from "clsx"
import { useEffect, useState } from "react"
import { FaChevronRight } from "react-icons/fa"

interface CareerDetailProps {
  data: Job
}

function CareerDetailPage({ data }: CareerDetailProps) {
  const [relatedJobs, setRelatedJobs] = useState<Job[]>([])
  const jobs = new JobsServices()

  const getAllRelatedJobs = async () => {
    try {
      const res = await jobs.getRelatedJobs({
        category_name: data?.category?.category_slug,
        career_id: data?.id,
      })
      if (res.isSuccess) {
        const result = res.getValue()
        setRelatedJobs(result.data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (data) {
      getAllRelatedJobs()
    }
  }, [data])

  return (
    <>
      <Helmet title={data?.category?.category_name} isIndexed />
      <Header />

      <main>
        <div className={clsx("sm:w-3/5 mx-auto sm:pt-5 sm:px-0", "pt-3 w-full px-4")}>
          <nav
            className={clsx(
              "flex sm:gap-4 sm:text-sm items-center sm:mb-[50px]",
              "text-xxs gap-2 mb-5"
            )}
          >
            <BasicLink href="/" className="text-grey-97 font-semibold">
              Beranda
            </BasicLink>
            <FaChevronRight className="sm:text-xxs text-[6px]" />
            <BasicLink
              href={`/jobs/${data?.category?.category_slug}`}
              className="text-grey-97 font-semibold"
            >
              {data?.category?.category_name}
            </BasicLink>
            <FaChevronRight className="sm:text-xxs text-[6px]" />
            <div className="text-green font-semibold">
              {data?.career_position?.position_name} - {data?.job_type}
            </div>
          </nav>

          <DetailBanner
            job_type={data?.job_type}
            job_system={data?.job_system}
            position_name={data?.career_position?.position_name}
            job_expired_at={data?.job_expired_at}
            created_at={data?.created_at}
            category_id={data?.category_id}
            career_position_id={data?.career_position_id}
          />
          <DetailBody
            job_benefit={data?.job_benefit}
            job_requirement_position={data?.job_requirement_position}
            job_description={data?.job_description}
          />
        </div>

        {relatedJobs.length ? <OtherVacancies relatedJobs={relatedJobs} /> : <></>}
      </main>

      <HariseninFooter />
    </>
  )
}

export default CareerDetailPage
